import axios from "axios";

import { store } from '../GlobalStateContainer';
import userManager from './userManager';
import { buildRequestUrl, execWithApiToken } from '../GlobalStateContainer/actions';

export function login(dispatch, returnLocation) {
    const state = store.getState();
    
    // If the user is already logged in (Authenticated), try checking their user info to make sure they're authorized
    if (state.oidc.user) {
        dispatch(fetchUserInfo);
        return;
    }

    // Prevent this from getting hit multiple times simultaneously
    if (state.userManager.loggingIn) {
        return;
    }

    // Commenting out logic for silent renewals for now as this seemed to be causing more issues than it solved given how long-lived our tokens are
    // const cmd = "SILENT_RENEW";

    // dispatch({ type: cmd });
    
    // // First try logging in "silently" - attempts to renew the token without user input
    // userManager.signinSilent()
    //     .then(
    //         _ => {
    //             dispatch({ type: cmd + '_FULFILLED' });
    //             dispatch(fetchUserInfo);
    //         },
    //         error => {
    //             // If silent renewal fails, do the full login flow with redirects
    //             dispatch({ type: "USER_LOGIN", payload: returnLocation.pathname });
    //             userManager.signinRedirect();
    //         });

    const cmd = "USER_LOGIN";

    dispatch({ type: cmd, payload: returnLocation.pathname });

    userManager.signinRedirect()
        .catch((err) => {
            dispatch({ type: cmd + "_ERROR" });
        });
}

export function signinSilent(dispatch, resolve) {
    dispatch({ type: "SILENT_RENEW" });
    userManager.signinSilent()
        .then(user => resolve(dispatch, user.access_token));
}

export function loginError(dispatch) {
    dispatch({ type: "USER_LOGIN_ERROR" });
}

export function logout(dispatch) {
    dispatch({ type: "USER_LOGOUT" });
    userManager.signoutRedirect();
}

/*
 * Logged in user
 *
 */

export function fetchUserInfo(dispatch) {
    const cmd = 'FETCH_USER_INFO';
  
    execWithApiToken(dispatch, cmd, (dispatch, token) => {
        dispatch({ type: cmd });

        axios.get(buildRequestUrl('Users/Info'), { headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token } })
            .then(
            (resp) => { 
                dispatch({ type: cmd + '_FULFILLED', payload: resp }) 

                const state = store.getState();

                var userData = {
                    user: state.userManager.userInfo.userName,
                    userFullName: state.userManager.userInfo.firstName + ' ' + state.userManager.userInfo.lastName,
                    bidadmin: state.userManager && state.userManager.roles && state.userManager.roles[0] && state.userManager.roles[0].assigned,
                    sowadmin: state.userManager && state.userManager.roles && state.userManager.roles[1] && state.userManager.roles[1].assigned
                }

                dispatch({ type: 'SET_USER', payload: { data: userData } })                               
            },
            (err) => dispatch({ type: cmd + '_REJECTED', payload: err })
        );
    });
}
